import { useEffect, useState } from 'react';

interface ImageReady {
    src: string | undefined;
    key: string;
}

export const useImagePreload = (src: string, key = ''): ImageReady => {
    const [imageReady, setImageReady] = useState<ImageReady>({ src, key });

    useEffect(() => {
        if (!src) {
            setImageReady((prev) => ({ ...prev, src: undefined }));
            return;
        }

        const image = new Image();

        let cancelled = false;

        const commit = () => {
            if (!cancelled) {
                setImageReady({ src, key });
            }
        };

        image.onload = commit;
        image.onerror = commit;
        image.src = src;

        return () => {
            cancelled = true;
            image.onload = null;
            image.onerror = null;
        };
    }, [key, src]);

    return imageReady;
};
